<template>
    <b-form-group :label="formLabel" :description="description">
        <multiselect
            id="departments"
            :state="state"
            :selected="value"
            :options="options"
            :disabled="disabled"
            :loading="isLoading"
            :placeholder="placeholder"
            :groupLabel="groupLabelKey"
            :groupValues="groupValuesKey"
            :groupSelect="enableSelectAll"
            @changeValue="$emit('update:value', $event)"
            @click="getDepartments()"
            :numberOfSelectedOptionsToDisplay="limit"
        >
            <template slot="c-option" slot-scope="{ options: { option } }">
                <span>{{ option.label || option.$groupLabel }}</span>
            </template>
        </multiselect>
        <b-form-invalid-feedback :state="state">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import i18n from '@/i18n'
import api from '@/services/api'
import { orderBy } from 'lodash'
import { Multiselect, mapperToOptions } from '@/views/components/selects'

export default {
    name: 'Departments',
    components: {
        Multiselect,
    },
    props: {
        value: Array,
        showLabel: Boolean,
        enableSelectAll: {
            type: Boolean,
            default: false,
        },
        state: {
            type: Boolean,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        },
        loadDataWhenMounted: {
            type: Boolean,
            default: false,
        },
        applyAllSectionScope: null,
        limit: null,
        placeholder: {
            type: String,
            default: i18n.t('form.placeholder.select'),
        },
    },
    data() {
        return {
            departmentsOptions: [],
            isLoading: false,
        }
    },
    mounted() {
        if (this.loadDataWhenMounted) {
            this.getDepartments()
        }
        this.$emit('ready', true)
    },
    methods: {
        getDepartments() {
            if (!this.departmentsOptions.length) {
                this.isLoading = true
                api.get('/sections', {
                    params: {
                        ascending: 1,
                        searchFields: 'type:in',
                        search: 'type:department',
                        append: 'unit_name',
                        applyAllSectionScope: this.applyAllSectionScope,
                    },
                })
                    .then(resp => {
                        const {
                            data: { data },
                        } = resp
                        let sections = orderBy(data, 'unit_name')
                        this.departmentsOptions = mapperToOptions(
                            sections,
                            undefined,
                            'name'
                        )
                        this.fetchData()
                        if (this.value.length) {
                            let selectedsIDs = this.value.map(
                                item => item.value
                            )
                            const selecteds = this.departmentsOptions.filter(
                                option => {
                                    return selectedsIDs.includes(option.value)
                                }
                            )
                            this.$emit('update:value', selecteds)
                        }
                    })
                    .catch(e => {
                        console.log(e)
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            }
        },
        fetchData() {
            this.$store.dispatch('filterDepartments', this.departmentsOptions)
            this.$emit('loaded', true)
        },
    },
    computed: {
        formLabel() {
            return this.showLabel
                ? this.label
                    ? this.label
                    : i18n.t('form.label.departments')
                : null
        },
        groupValuesKey() {
            return this.enableSelectAll ? 'items' : null
        },
        groupLabelKey() {
            return this.enableSelectAll ? 'group' : null
        },
        options() {
            const items = this.departmentsOptions

            if (this.enableSelectAll) {
                return [{ items, group: i18n.t('form.button.allOptions') }]
            }

            return items
        },
    },
}
</script>
